export default __webpack_public_path__ + "static/spot-urinary-229f2274c4823b03107f65cc846daa7d.jpg";